import React from 'react';

const SuccessIcon = () => <i className="fas fa-check-circle text-success" />;

export default SuccessIcon;
